module.exports = require("./lib/_stream_duplex.js")



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/duplex.js
// module id = 1048
// module chunks = 0